import React from 'react';
import {
	ApButtonIcon,
	ApButtonMain,
	ApButtonSecondary,
} from '@alixpartners/ui-components';
import {
	Overlay,
	CloseButton,
	Popup,
	ModalContent,
	EditActions,
} from './ConfirmModal.styles';

const ConfirmModal = ({ isOpen, onClose, children, deleteVendorData }) => {
	if (!isOpen) return null;

	return (
		<Overlay>
			<Popup>
				<CloseButton>
					<ApButtonIcon title="Close" iconName="close" onClick={onClose} />
				</CloseButton>
				<ModalContent>{children}</ModalContent>
				<EditActions>
					<div style={{ margin: '0 5px 0 0' }}>
						<ApButtonMain
							onClick={() => {
								deleteVendorData();
								onClose();
							}}
						>
							Confirm
						</ApButtonMain>
					</div>
					<div>
						<ApButtonSecondary onClick={onClose}>Close</ApButtonSecondary>
					</div>
				</EditActions>
			</Popup>
		</Overlay>
	);
};

export default ConfirmModal;
